import type { PageType } from 'types/page_type';

export const passwordResetRequestPage: Readonly<PageType> = {
  path: '/password/reset_request',
  title: 'パスワード再設定メール 送信',
  description: 'パスワード再設定メールの送信',
};

export const passwordEditPage: Readonly<PageType> = {
  path: '/password/edit',
  title: 'パスワード変更',
  description: 'パスワード変更',
};
